import {
  type TTimesheetsListDTO,
  timesheetsListSchema,
} from '../dto/timesheetsListDTO';

export const timesheetsListModel = (data: TTimesheetsListDTO) =>
  timesheetsListSchema.parse(data);
